import type { Effect } from './schema';

export const EFFECT_CATALOG: Array<{ type: Effect['type']; name: string; defaultValue: number; min: number; max: number; unit?: string }> = [
  { type: 'brightness', name: 'Brightness', defaultValue: 100, min: 0, max: 200, unit: '%' },
  { type: 'contrast', name: 'Contrast', defaultValue: 100, min: 0, max: 200, unit: '%' },
  { type: 'saturation', name: 'Saturation', defaultValue: 100, min: 0, max: 200, unit: '%' },
  { type: 'hue', name: 'Hue rotate', defaultValue: 0, min: -180, max: 180, unit: '°' },
  { type: 'blur', name: 'Gaussian blur', defaultValue: 0, min: 0, max: 40, unit: 'px' },
  { type: 'sharpen', name: 'Sharpen', defaultValue: 0, min: 0, max: 100, unit: '%' },
  { type: 'vignette', name: 'Vignette', defaultValue: 0, min: 0, max: 100, unit: '%' },
  { type: 'noise', name: 'Film noise', defaultValue: 0, min: 0, max: 100, unit: '%' },
  { type: 'chromatic-aberration', name: 'Chromatic aberration', defaultValue: 0, min: 0, max: 30, unit: 'px' }
];

export function effectToCanvasFilter(effects: Effect[]): string {
  const enabled = effects.filter((effect) => effect.enabled);
  const value = (type: Effect['type'], fallback: number) => Number(enabled.find((effect) => effect.type === type)?.params.value ?? fallback);
  return [
    `brightness(${value('brightness', 100)}%)`,
    `contrast(${value('contrast', 100)}%)`,
    `saturate(${value('saturation', 100)}%)`,
    `hue-rotate(${value('hue', 0)}deg)`,
    `blur(${value('blur', 0)}px)`
  ].join(' ');
}
